import src from "IMAGE";
export default { src, width: 181, height: 161, blurWidth: 0, blurHeight: 0};
